"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.csvHeaders = void 0;
var poleSchema = {
  projectId: '',
  info: {
    name: '',
    date: '',
    ansiLength: '',
    ansiSpecies: '',
    ansiClass: '',
    isLinearTaper: false,
    userEmbedment: '',
    fiberStrength: 0
  },
  damageParameters: {
    1: {
      diameter: 0,
      distanceFromGround: 0,
      damages: []
    },
    2: {
      diameter: 0,
      distanceFromGround: 0,
      damages: []
    },
    3: {
      diameter: 0,
      distanceFromGround: 0,
      damages: []
    }
  },
  output: {
    1: {
      actual: {
        momentInertiaX: 0,
        momentSlopeY: 0,
        momentSlopeX: 0,
        momentInertiaY: 0,
        area: 0
      },
      original: {
        momentInertiaX: 0,
        momentSlopeY: 0,
        momentSlopeX: 0,
        momentInertiaY: 0,
        area: 0
      },
      ansi: {
        momentInertiaX: 0,
        momentSlopeY: 0,
        momentSlopeX: 0,
        momentInertiaY: 0,
        area: 0
      },
      svg: '',
      ansiDiameter: 0
    },
    2: {
      actual: {
        momentInertiaX: 0,
        momentSlopeY: 0,
        momentSlopeX: 0,
        momentInertiaY: 0,
        area: 0
      },
      original: {
        momentInertiaX: 0,
        momentSlopeY: 0,
        momentSlopeX: 0,
        momentInertiaY: 0,
        area: 0
      },
      ansi: {
        momentInertiaX: 0,
        momentSlopeY: 0,
        momentSlopeX: 0,
        momentInertiaY: 0,
        area: 0
      },
      svg: '',
      ansiDiameter: 0
    },
    3: {
      actual: {
        momentInertiaX: 0,
        momentSlopeY: 0,
        momentSlopeX: 0,
        momentInertiaY: 0,
        area: 0
      },
      original: {
        momentInertiaX: 0,
        momentSlopeY: 0,
        momentSlopeX: 0,
        momentInertiaY: 0,
        area: 0
      },
      ansi: {
        momentInertiaX: 0,
        momentSlopeY: 0,
        momentSlopeX: 0,
        momentInertiaY: 0,
        area: 0
      },
      svg: '',
      ansiDiameter: 0
    }
  }
};
var _default = exports["default"] = poleSchema;
var csvHeaders = exports.csvHeaders = ['pole_name', 'project_id', 'id', 'date', 'length', 'species', 'class', 'isLinearTaper', 'userEmbedment', 'fiberStrength', 'taper', 'embedment', 'ansi_dia', 'l1_diameter', 'l1_circumference', 'l1_dist_from_groundline', 'l1_d1_type1', 'l1_d1_param1', 'l1_d1_param2', 'l1_d1_param3', 'l1_d1_param4', 'l1_d2_type1', 'l1_d2_param1', 'l1_d2_param2', 'l1_d2_param3', 'l1_d2_param4', 'l1_d3_type1', 'l1_d3_param1', 'l1_d3_param2', 'l1_d3_param3', 'l1_d3_param4', 'l1_d4_type1', 'l1_d4_param1', 'l1_d4_param2', 'l1_d4_param3', 'l1_d4_param4', 'l2_diameter', 'l2_circumference', 'l2_dist_from_groundline', 'l2_d1_type1', 'l2_d1_param1', 'l2_d1_param2', 'l2_d1_param3', 'l2_d1_param4', 'l2_d2_type1', 'l2_d2_param1', 'l2_d2_param2', 'l2_d2_param3', 'l2_d2_param4', 'l2_d3_type1', 'l2_d3_param1', 'l2_d3_param2', 'l2_d3_param3', 'l2_d3_param4', 'l2_d4_type1', 'l2_d4_param1', 'l2_d4_param2', 'l2_d4_param3', 'l2_d4_param4', 'l3_diameter', 'l3_circumference', 'l3_dist_from_groundline', 'l3_d1_type1', 'l3_d1_param1', 'l3_d1_param2', 'l3_d1_param3', 'l3_d1_param4', 'l3_d2_type1', 'l3_d2_param1', 'l3_d2_param2', 'l3_d2_param3', 'l3_d2_param4', 'l3_d3_type1', 'l3_d3_param1', 'l3_d3_param2', 'l3_d3_param3', 'l3_d3_param4', 'l3_d4_type1', 'l3_d4_param1', 'l3_d4_param2', 'l3_d4_param3', 'l3_d4_param4', 'area_l1', 'area_percent_l1', 'section_modulus_inline_l1', 'section_modulus_inline_percent_l1', 'section_modulus_transverse_l1', 'section_modulus_transverse_percent_l1', 'moment_of_inertia_inline_l1', 'moment_of_inertia_inline_percent_l1', 'moment_of_inertia_transverse_l1', 'moment_of_inertia_transverse_percent_l1', 'area_l2', 'area_percent_l2', 'section_modulus_inline_l2', 'section_modulus_inline_percent_l2', 'section_modulus_transverse_l2', 'section_modulus_transverse_percent_l2', 'moment_of_inertia_inline_l2', 'moment_of_inertia_inline_percent_l2', 'moment_of_inertia_transverse_l2', 'moment_of_inertia_transverse_percent_l2', 'area_l3', 'area_percent_l3', 'section_modulus_inline_l3', 'section_modulus_inline_percent_l3', 'section_modulus_transverse_l3', 'section_modulus_transverse_percent_l3', 'moment_of_inertia_inline_l3', 'moment_of_inertia_inline_percent_l3', 'moment_of_inertia_transverse_l3', 'moment_of_inertia_transverse_percent_l3', 'svg_string_l1', 'svg_string_l2', 'svg_string_l3'];